import { SwitchWrap, SwitchInput, SwitchCustom, SwitchLabel } from './styled'

const Switch = ({ label, className, disabled, ...otherProps }) => {
  return (
    <SwitchWrap className={className} $disabled={disabled}>
      <SwitchInput disabled={disabled} {...otherProps} />
      <SwitchCustom $disabled={disabled} />
      <SwitchLabel $disabled={disabled}>{label}</SwitchLabel>
    </SwitchWrap>
  )
}

export default Switch
